import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import CustomAccordion from 'on_web/components/shared/CustomAccordion/CustomAccordion';

/**
 * Component displaying list of condition summaries. Each condition summary is displayed with ConditionSummary component.
 * @param {Component properties} props
 */
export default function CustomAccordionList(props) {
  const useStyles = makeStyles(() => ({
    root: {
      flexGrow: 1,
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Grid container direction="row">
          {props.conditionSummaries.map((conditionSummary, ix) => {
            return (
              <Grid item xs={12} key={ix}>
                <Box my={'1.5px'}>
                  <CustomAccordion
                    defaultExpanded={ix === 0}
                    risk={conditionSummary}
                  />
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
}

CustomAccordionList.propTypes = {
  /**
   * Array with condition summaries
   */
  conditionSummaries: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Comorbidity level
       */
      level: PropTypes.number.isRequired,

      /**
       * Label for comorbidity level.
       */
      level_label: PropTypes.string.isRequired,

      risk: PropTypes.shape({
        code: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,

  /**
   * Name of the category to which conditions belong
   */
  category: PropTypes.string.isRequired,
};
